export default __webpack_public_path__ + "static/media/1869.307a81ac.png";